import React from 'react';

import Select from 'react-select';

export default function MultiSelectField({
    onChange,
    options,
    value,
    className,
    isDisabled = false,
    isGrouped = false,
    clearable = false,
    backgroundColor = 'white',
    showIndentation = false,
    hideSelectedOptions = true,
    height = 36,
    placeholder,
    styles,
    inputId,
}) {
    const groupStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    };

    const groupBadgeStyles = {
        backgroundColor: '#EBECF0',
        borderRadius: '2em',
        color: '#172B4D',
        display: 'inline-block',
        fontSize: 12,
        fontWeight: 'normal',
        lineHeight: '1',
        minWidth: 1,
        padding: '0.16666666666667em 0.5em',
        textAlign: 'center',
    };

    const formatGroupLabel = (data) => (
        <>
            {!!data.groupLabel && (
                <div style={groupStyles}>
                    <span>{data.groupLabel}</span>
                </div>
            )}
            <div style={groupStyles}>
                <span>{data.label}</span>
                <span style={groupBadgeStyles}>{data.options.length}</span>
            </div>
        </>
    );

    const defaultValue = (options, value) => {
        // Handle array of values for multi-select
        if (isGrouped) {
            const selectedOptions = [];
            options.forEach((group) => {
                group.options.forEach((option) => {
                    if (value.includes(option.value)) {
                        selectedOptions.push(option);
                    }
                });
            });
            return selectedOptions;
        }
        return options ? options.filter((option) => value.includes(option.value)) : [];
    };
    return (
        <div className={className}>
            <Select
                isMulti
                placeholder={placeholder}
                inputId={inputId}
                isDisabled={isDisabled}
                isClearable={clearable}
                hideSelectedOptions={hideSelectedOptions}
                value={defaultValue(options, value)}
                onChange={(value) => onChange(value)}
                options={options}
                menuPortalTarget={document.body}
                styles={{
                    // `height` is a floor, never a ceiling: once the selected
                    // chips outgrow one line the container wraps and the field
                    // grows, so every selection stays visible and removable.
                    control: (baseStyles, state) => ({
                        ...baseStyles,
                        minHeight: height,
                        backgroundColor: backgroundColor,
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    valueContainer: (provided, state) => ({
                        ...provided,
                        minHeight: height,
                        flexWrap: 'wrap',
                        padding: '0 6px',
                    }),
                    input: (provided, state) => ({
                        ...provided,
                        margin: '0px',
                    }),
                    indicatorsContainer: (provided, state) => ({
                        ...provided,
                        minHeight: height,
                    }),
                    option: (provided, state) => ({
                        ...provided,
                        paddingLeft: showIndentation && state.data.level ? `${state.data.level * 24}px` : provided.paddingLeft, // Adjust indentation based on 'level'
                    }),
                    ...styles,
                }}
                className="react-select-container"
                classNamePrefix="react-select"
                formatGroupLabel={formatGroupLabel}
            />
        </div>
    );
}
